module.exports = __webpack_public_path__ + "img/max-file-sync--excel.08b51694.svg";